"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var system_1 = require("@retriever-ui/system");
var react_1 = __importDefault(require("react"));
var use_debounce_1 = require("use-debounce");
var useOutsideClick_1 = require("../../../Utils/useOutsideClick");
var select_context_1 = require("../../select.context");
var S = __importStar(require("../common.styled"));
var InputSearchable = function (_a) {
    var contentRef = _a.contentRef, _b = _a.debounceTime, debounceTime = _b === void 0 ? 0 : _b;
    var inputRef = react_1.default.useRef(null);
    var _c = (0, select_context_1.useSelect)(), optionSelected = _c.optionSelected, errored = _c.errored, placeholder = _c.placeholder, disabled = _c.disabled, readOnly = _c.readOnly, setOptionsVisible = _c.setOptionsVisible, optionsVisible = _c.optionsVisible, setSearchFilter = _c.setSearchFilter, value = _c.value;
    var hideOptions = react_1.default.useCallback(function () {
        if (inputRef && inputRef.current) {
            setOptionsVisible(false);
            setSearchFilter('');
            inputRef.current.value = '';
        }
    }, [inputRef]);
    var handleChange = (0, use_debounce_1.useDebouncedCallback)(function (e) {
        setSearchFilter(e.target.value);
    }, debounceTime);
    var handleClickOrFocus = react_1.default.useCallback(function () {
        if (!disabled && !readOnly) {
            if (!optionsVisible)
                setOptionsVisible(true);
        }
    }, [disabled, readOnly, optionsVisible]);
    (0, useOutsideClick_1.useOutsideClick)(inputRef, function (e) {
        if (e.target && contentRef && !contentRef.contains(e.target)) {
            hideOptions();
        }
    });
    react_1.default.useEffect(function () {
        if (inputRef.current)
            inputRef.current.value = '';
        setSearchFilter('');
    }, [optionSelected, value]);
    react_1.default.useEffect(function () {
        if (inputRef && inputRef.current) {
            var tabPress_1 = function (e) {
                var key = e.key || e.keyCode;
                if (key === 'Tab' || key === 9) {
                    hideOptions();
                }
            };
            inputRef.current.addEventListener('keydown', tabPress_1);
            return function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', tabPress_1); };
        }
    }, [inputRef, hideOptions]);
    return (react_1.default.createElement(system_1.retriever.div, { position: "relative" },
        react_1.default.createElement(S.SelectInput, { hasOptionSelected: (value === null || value === void 0 ? void 0 : value.value) !== undefined || (optionSelected === null || optionSelected === void 0 ? void 0 : optionSelected.value) !== undefined, optionVisible: optionsVisible, errored: errored, disabled: disabled || false, readOnly: readOnly || false, onClick: handleClickOrFocus, onFocus: handleClickOrFocus, onChange: handleChange, placeholder: (value === null || value === void 0 ? void 0 : value.label) || (optionSelected === null || optionSelected === void 0 ? void 0 : optionSelected.label) || placeholder, ref: inputRef }),
        react_1.default.createElement(S.Arrow, { optionVisible: optionsVisible })));
};
exports.default = InputSearchable;
